import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { SER_BASIC_Schema } from './SER_BASIC_Schema';

/** 평가 목록 조회 */
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;

  const query = useQuery({
    queryKey: ['SeriousAccidentAct', 'getSerBasicR1'],
    queryFn: () => {
      const params = mapParamsBySchema(SER_BASIC_Schema.mapper.search1);
      return apiRequest(
        'post',
        Global.urls.SeriousAccidentAct.getSerBasicR1,
        params
      );
    },
    enabled: false,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

/** 조건 기반 목록 조회 */
export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      SER_BASIC_Schema.mapper.search1,
      context
    );
    return apiRequest(
      'post',
      Global.urls.SeriousAccidentAct.getSerBasicR1,
      params
    );
  }, successOptions);
};

/** 평가 삭제 (soft delete) */
export const useDelete1 = (context = {}, options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payloads = mapRowsBySchema(
      rows,
      SER_BASIC_Schema.mapper.delete1,
      context
    );
    const payload = payloads?.[0] ?? {};
    return apiRequest(
      'post1',
      Global.urls.SeriousAccidentAct.deleteSerBasicD1,
      payload
    );
  }, options);
};
